module.exports = __webpack_public_path__ + "static/media/4-Clubs.762a1efa.svg";